import { Divider, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import { getPickslipPickLog } from "services/data.outbound.service";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

function PickslipPickScanLog({ open, setOpen, logRequest, setLogRequest }) {
  const columns = [
    { label: "Basket Id", id: "basketId" },
    { label: "Package Id", id: "packageId" },
    { label: "Location Id", id: "locationId" },
    { label: "Pallet Number", id: "palletNbr" },
    { label: "Carton Id", id: "cartonId" },
    { label: "SKU Code", id: "skuCode" },
    { label: "MLN", id: "mln" },
    { label: "Expiry Date", id: "expiryDate" },
    { label: "Qty Allocate", id: "quantityAllocate" },
    { label: "Qty Picked", id: "quantityPicked" },
    { label: "Base UOM", id: "baseUOM" },
    { label: "Status", id: "status" },
    //{ label: "Created On", id: "createdOn" },
    //{ label: "Updated On", id: "updatedOn" }
  ];
  const { data } = useQuery({
    queryKey: ["pickslip-pick-log", { logRequest }],
    queryFn: () => getPickslipPickLog(logRequest),
    enabled: Boolean(logRequest),
  });

  const details = data?.data.data.details.map((d) => ({
    ...d,
    status:
      d.status === "O" ? (
        <MDBadge variant="gradient" color="warning" size="xs" badgeContent="Scanning" container />
      ) : (
        <MDBadge variant="gradient" color="success" size="xs" badgeContent="Complete" container />
      ),
  }));

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogRequest(null);
  };

  return (
    <Drawer width="1400px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        Pickslip Pick Scan
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {Boolean(data) && (
        <>
          <MDBox style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Pickslip Number : </b>
                {logRequest.pickslipNumber}
              </Grid>
            </Grid>
          </MDBox>
          <StickyHeadTable columns={columns} rows={details} />
        </>
      )}
    </Drawer>
  );
}

export default PickslipPickScanLog;
